import React, { Component } from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import DateTimeDisplay from '../../../../../components/date-time-display';
import styles from './styles.css';

class SurveyEmailRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.showStatus = this.showStatus.bind(this);
  }

  getTimes(date) {
    const { data } = this.props;
    let foreignTime = null;
    const m = moment(date);
    const localTime = {
      date: m.isValid() ? m : null,
    };
    if (m.isValid() && data.time_zone !== null && data.time_zone !== undefined && data.time_zone.utc !== null) {
      localTime.date = moment(date).tz(data.time_zone.utc);
      foreignTime = {
        date: moment(date),
        utc: data.time_zone.utc,
      };
    }
    return {
      localTime,
      foreignTime,
    };
  }

  showStatus(e) {
    e.preventDefault();
    const {
      isNext, data, object,
    } = this.props;

    const subject = isNext ? (data.next_scheduled_subject || data.next_email_subject) : data.last_email_subject;
    const message = isNext ? (data.next_scheduled_message || data.next_email_message) : data.last_email_message;
    this.props.requestShowEmail({
      id: data.id,
      subject,
      email: data.email,
      name: `${data.first_name} ${data.last_name}`,
      message,
      date: isNext ? data.next_email_date : data.last_email_date,
      step_id: data.next_step_id,
      status: data.last_status,
      contact_id: data.id,
      collector_id: data.collector_id,
      collector_email: data.collector_email,
      collector_name: data.collector_name,
      opportunity_id: object.opportunity_id,
      account_id: object.account_id,
      is_manual: data.is_manual,
      time_zone: data.time_zone,
      isNext,
      email_from: isNext ? data.email_from : data.last_email_from,
      program_id: data.program_id,
      client_id: data.client_id,
    });
  }
  
  renderTime(localTime, foreignTime) {
    if (!localTime || !localTime.date) {
      return 'unknow';
    }
    const format = 'MMM DD, YYYY \\a\\t hh:mm A';
    let localSuffix = null;
    const localStr = localTime.date.format(format);
    let foreignTimeStr = null;

    if (foreignTime !== null) {
      foreignTimeStr = foreignTime.date.format(format);
    }
    if (foreignTimeStr && foreignTimeStr !== localStr) {
      localSuffix = (<span className="label label-default text-uppercase">local time</span>);
    }
    return (
      <div>
        <div><nobr>{localStr} {localSuffix}</nobr></div>
        {foreignTime !== null && foreignTimeStr !== localStr &&
          <div>
            <em>or</em>
            <div><nobr>{foreignTimeStr} <span className="label label-default text-uppercase">{foreignTime.utc}</span></nobr></div>
          </div>
        }
      </div>
    );
  }

  renderContent() {
    const { data, isNext, clickable } = this.props;
    const title = isNext ? 'Next Email' : 'Last Email Sent';
    const dateLabel = isNext ? 'Scheduled' : 'Sent on';
    const date = isNext ? data.next_email_date : data.last_email_date;
    const isActive = data.contact_status === 'ACTIVE';
    let isManual = false;
    if (isNext && date === 'Manual') {
      isManual = true;
    } else if (data.is_manual) {
      isManual = true;
    }

    if ((isNext && !isActive) || (!isNext && !date)) {
      return (
        <span className="text-muted">&mdash;</span>
      );
    }
    const { localTime, foreignTime } = this.getTimes(date);
    const subject = isNext ? (data.next_scheduled_subject || data.next_email_subject) : data.last_email_subject;
    const status = !isNext && data.last_status ? data.last_status : null;
    const statusCls = status === 'SENT' ? 'label-success' : 'label-default';

    const popover = (
      <Tooltip id={`reason-${data.id}`} className={styles.popover}>
        <div className="text-left">
          <div><strong>{title}:</strong></div>
          <table className="table table-condensed">
            <tbody>
              <tr>
                <td>Subject:</td>
                <td>{subject}</td>
              </tr>
              <tr>
                <td><nobr>{dateLabel}:</nobr></td>
                <td>
                  {(!isManual || !isNext) && this.renderTime(localTime, foreignTime)}
                  {isManual && isNext && <em>manual</em>}
                </td>
              </tr>
              {!isNext && data.last_status !== null &&
                <tr>
                  <td>Status:</td>
                  <td><span className={`label ${statusCls}`}>{status}</span></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </Tooltip>
    );
    
    const hasDate = localTime && localTime.date !== null;
    const inner = (
      <OverlayTrigger key={data._id} trigger={['hover', 'focus']} placement="top" overlay={popover}>
        <span>
          {hasDate && <DateTimeDisplay value={localTime.date} format="dddd, MMMM DD \a\t hh:mm A" />}
          {!isManual && !hasDate && <span>unknown</span>}
          {isManual && !hasDate && <em>manual</em>}
        </span>
      </OverlayTrigger>
    );
    if (!clickable) {
      return inner;
    }
    return (
      <a
        href=""
        onClick={this.showStatus}
      >
        {inner}
      </a>
    );
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

SurveyEmailRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
    collector_id: PropTypes.string,
    last_status: PropTypes.string,
    last_email_subject: PropTypes.string,
    last_email_message: PropTypes.string,
    next_email_subject: PropTypes.string,
    next_email_message: PropTypes.string,
    contact_status: PropTypes.string,
    is_manual: PropTypes.bool,
    time_zone: PropTypes.shape({
      utc: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  object: PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  requestShowEmail: PropTypes.func,
  isNext: PropTypes.bool,
  clickable: PropTypes.bool,
};
SurveyEmailRenderer.defaultProps = {
  data: null,
  object: null,
  node: null,
  requestShowEmail: () => {},
  isNext: false,
  clickable: true,
};

export default SurveyEmailRenderer;
